import React from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Primitive Typography component
 * Styled version of MUI Typography that respects the theme
 */
const Typography = ({ children, ...props }) => {
  const theme = useTheme();

  return (
    <MuiTypography
      {...props}
      sx={{
        ...props.sx,
      }}
    >
      {children}
    </MuiTypography>
  );
};

export default Typography;

